export default {
  /**
   * Must be in sync with values defined in bootstrap variables!
   */
  grid: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1024,
    xl: 1366,
    xxl: 1920,
    xxxl: 2560,
  },
  current() {
    let name;
    Object.keys(this.grid).some((key) => {
      if (window.innerWidth < this.grid[key]) {
        return true;
      }
      name = key;
      return false;
    });
    return name;
  },
  isUp(name) {
    return window.innerWidth >= this.grid[name];
  },
};
